import axios, {AxiosResponse} from 'axios'
import {
  ActivityQueryResponse,
  AuthLogQueryResponse,
} from './_models'

export const getActivity = (query: string): Promise<ActivityQueryResponse> => {
  return axios
    .get(`/p2c/logs/activity?${query}`)
    .then((d: AxiosResponse<ActivityQueryResponse>) => {
      return d.data
    })
}

export const getAuthLog = (query: string): Promise<AuthLogQueryResponse> => {
  return axios
    .get(`/p2c/logs/auth?${query}`)
    .then((d: AxiosResponse<AuthLogQueryResponse>) => {
      return d.data
    })
}

